import { Layout, Skeleton, Typography } from "antd";
import React, { useRef } from "react";
import {
  initPrincipalUserSlice,
  setPropertiesUser,
  updateUser,
} from "../Slices/PrincipalUser.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { renderUserName, roles, subRoles } from "../../../utils/constants";
import { PrincipalUserForms } from "./PrincipalUserForms";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { sendEmailInvitation } from "../../../engine/api/apiRequest";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";

const { Content, Sider, Header, Footer } = Layout;

export function PrincipalUser({ unitId, expanded, onClose }) {
  const { id, user: userId } = useParams();
  const loc = useLocation();

  const { principal, loading, user } = useSelector(state => state.user);

  const navigate = useNavigate();

  const { init, clear } = initPrincipalUserSlice({ id, userId });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const onSubmitForm = async data => {
    if (userId === "new") {
      data.principal = id;
      data.role = roles.mandant;
    }


    await dispatch(setPropertiesUser(data));
    dispatch(updateUser());
  };

  const inputs = PrincipalUserForms({ user });
  const emailInvitationDisabled = () => {
    if (user.email === "") {
      return true;
    }


    if (
      user.subRoles.length === 1 &&
      user.subRoles.includes(subRoles.institutionIntervenant)
    ) {
      return true;
    }
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {userId === "new"
          ? routes.principals(id).detailUser().title
          : renderUserName(user)}
      </Typography.Title>
      <ActionDropdown>
        <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
          <a
            onClick={() =>
              !emailInvitationDisabled() && sendEmailInvitation(userId)
            }
            disabled={emailInvitationDisabled()}
          >
            Envoyer un email d'invitation
          </a>
        </ActionRoleSpecific>
      </ActionDropdown>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomForm
            rule={routes.principals(id).detailUser()}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
